var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSenegalFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.68 473.68",
    style: {
      enableBackground: "new 0 0 473.68 473.68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32027"
    },
    d: "M315.8,13.535l-27.64,76.624c25.511,84.2,25.511,209.162,0,293.358l27.639,76.624 c91.975-32.524,157.881-120.201,157.881-223.31S407.774,46.055,315.8,13.535z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8D12E"
    },
    d: "M315.8,90.159V13.535C291.1,4.8,264.534,0.002,236.838,0.002 C273.359,0.002,222.722,123.774,315.8,90.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8D12E"
    },
    d: "M236.838,473.678c27.695,0,54.261-4.798,78.961-13.534V383.52 C223.656,374.326,236.838,473.678,236.838,473.678z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14B36F"
    },
    d: "M0,236.837C0,340.289,66.355,428.198,158.805,460.46V13.221C66.355,45.483,0,133.384,0,236.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E73B36"
    },
    d: "M315.8,90.159v293.358C341.315,299.321,341.315,174.358,315.8,90.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC4D"
    },
    d: "M315.8,383.521V90.159c-16.125-53.222-42.44-90.157-78.961-90.157 c-27.351,0-53.592,4.689-78.034,13.219v447.238c24.442,8.522,50.682,13.219,78.034,13.219 C273.359,473.678,299.674,436.743,315.8,383.521z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#14B36F"
    },
    points: "238.364,174.965 253.678,222.095 303.235,222.095 263.143,251.219 278.456,298.349  238.364,269.221 198.276,298.349 213.586,251.219 173.498,222.095 223.054,222.095 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenegalFlag);
export default __webpack_public_path__ + "static/media/senegal-flag.dd819c9a153d19df7842d041eaf0a1cb.svg";
export { ForwardRef as ReactComponent };